export default __webpack_public_path__ + "static/media/featRaceBg.a726bf85.png";